/* Sticky CTA reveal — shows the bottom button after the 4th reason scrolls in,
   then hides it once the main buybox enters view */
(function(){
  var el=document.getElementById('listicle-sticky-btn');
  if(!el)return;
  function check(){
    var reasons=document.querySelectorAll('.listicle-reason-wrap');
    var trigger=reasons[3];
    var buybox=document.querySelector('.listicle-cta-v1-section');
    if(!trigger||!buybox)return;
    var tr=trigger.getBoundingClientRect();
    var br=buybox.getBoundingClientRect();
    var show=tr.top<window.innerHeight*0.5 && br.top>window.innerHeight*0.8;
    el.classList.toggle('is-visible',show);
  }
  window.addEventListener('scroll',check,{passive:true});
  window.addEventListener('resize',check,{passive:true});
  if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',check);} else {check();}
})();

/* Evergreen countdown — resets every 7 days via cookie so the same visitor sees
   the offer expire at a consistent local time across sessions */
(function(){
  var DURATION_SEC = 1*3600 + 39*60;
  var COOKIE = 'cd_endtime_v2';
  function getCookie(name){
    var m = document.cookie.match(new RegExp('(?:^|; )'+name+'=([^;]*)'));
    return m ? parseInt(decodeURIComponent(m[1]), 10) : null;
  }
  function setCookie(name, value){
    var d = new Date(); d.setTime(d.getTime() + 7*24*3600*1000);
    document.cookie = name+'='+encodeURIComponent(value)+';expires='+d.toUTCString()+';path=/;SameSite=Lax';
  }
  var endTime = getCookie(COOKIE);
  if (!endTime || isNaN(endTime) || endTime <= Date.now()) {
    endTime = Date.now() + DURATION_SEC * 1000;
    setCookie(COOKIE, endTime);
  }
  function pad(n){ return n < 10 ? '0'+n : ''+n; }
  function tick(){
    var remainingMs = endTime - Date.now();
    if (remainingMs <= 0) {
      endTime = Date.now() + DURATION_SEC * 1000;
      setCookie(COOKIE, endTime);
      remainingMs = endTime - Date.now();
    }
    var s = Math.floor(remainingMs / 1000);
    var h = Math.floor(s / 3600);
    var m = Math.floor((s % 3600) / 60);
    var sec = s % 60;
    var text = pad(h)+':'+pad(m)+':'+pad(sec);
    document.querySelectorAll('[data-countdown]').forEach(function(el){ el.textContent = text; });
  }
  function start(){ tick(); setInterval(tick, 1000); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
